import { Alert } from 'react-bootstrap';
import React, { useState } from 'react';

function CodeArea(lines) {
  const [code, setCode] = useState(lines);
  return (
    <Alert
    variant="success"
    style = {{
      marginTop:20,
    }}
    >
      {console.log(code)}
      <pre>
      <code
        style = {{
          textAlign:"left",
          color:"#118811",
          whiteSpace: 'pre-line'
        }}
      >
      {
        code.lines.map(line=>
          <div 
          style =
          {{
            textIndent:line.indent * 20,
          }}>{line.body}</div>
        )
      }
      </code></pre>
    </Alert>
  );
}
export default CodeArea;
